export const menuContentDefaultClasses = [
  'bg-surface',
  'rounded-lg',
  '[filter:drop-shadow(0px_4px_4px_var(--palette-black-alpha-50))_drop-shadow(0px_0px_1px_var(--color-border))_drop-shadow(0px_1px_1px_var(--palette-black-alpha-100))_drop-shadow(0px_14px_32px_var(--palette-black-alpha-50))]',
  'p-4',
  'flex',
  'flex-col',
  'gap-0.5',
  'z-modal',
  'max-w-[calc(100vw-(--spacing(8)))]',
  'focus:outline-none',
  'data-[side="bottom"]:motion-safe:animate-fade-in-bottom',
  'data-[side="top"]:motion-safe:animate-fade-in-top',
  'data-[side="left"]:motion-safe:animate-fade-in-left',
  'data-[side="right"]:motion-safe:animate-fade-in-right',
];
